/* eslint-disable import/prefer-default-export */
import config from './config';
import { dataReturn } from './utils';

const URL_BASE = config.hostApiTalent;

// const token = sessionStorage.getItem('token');

export async function GetAllMentors() {
  const API_URL = `${URL_BASE}/mentors`;
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
  };
  const response = await fetch(API_URL, requestOptions);
  const data = await response.json();
  return dataReturn(response, data);
}
